import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { PriceEntry } from './ArtworkPriceTracker';
type PriceGraphProps = {
  data: PriceEntry[];
  artworkName: string;
};
export function PriceGraph({
  data,
  artworkName
}: PriceGraphProps) {
  // Format data for the chart
  const chartData = data.map(entry => ({
    year: entry.year,
    percentage: entry.price
  }));
  // Calculate price increase percentage if we have at least 2 data points
  const calculateIncrease = () => {
    if (data.length < 2) return null;
    const sortedData = [...data].sort((a, b) => a.year - b.year);
    const lastPercentage = sortedData[sortedData.length - 1].price;
    return {
      percentage: lastPercentage - 100
    };
  };
  const increase = calculateIncrease();
  // Custom tooltip formatter
  const formatTooltip = (value: number) => {
    return `${value.toFixed(1)}%`;
  };
  return <div className="h-full flex flex-col" data-id="element-63">
      {data.length < 2 ? <div className="h-[200px] flex items-center justify-center text-gray-500 text-center p-4" data-id="element-64">
          Add at least two value points to generate a graph
        </div> : <>
          <div className="mb-4" data-id="element-65">
            {increase && <div className="bg-gradient-to-r from-indigo-50 to-purple-50 p-3 rounded-md border border-indigo-100" data-id="element-66">
                <p className="text-sm text-gray-800" data-id="element-67">
                  <span className="font-medium" data-id="element-68">Total Growth:</span>{' '}
                  {increase.percentage > 0 ? '+' : ''}
                  {increase.percentage.toFixed(1)}%
                </p>
              </div>}
          </div>
          <div className="h-[300px]" data-id="element-69">
            <ResponsiveContainer width="100%" height="100%" data-id="element-70">
              <LineChart data={chartData} margin={{
            top: 20,
            right: 30,
            left: 30,
            bottom: 30
          }} data-id="element-71">
                <defs data-id="element-72">
                  <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1" data-id="element-73">
                    <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8} data-id="element-74" />
                    <stop offset="95%" stopColor="#8884d8" stopOpacity={0.2} data-id="element-75" />
                  </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" data-id="element-76" />
                <XAxis dataKey="year" label={{
              value: 'Year',
              position: 'insideBottom',
              offset: -20
            }} stroke="#666" padding={{
              left: 30,
              right: 30
            }} data-id="element-77" />
                <YAxis tickFormatter={formatTooltip} label={{
              value: 'Value (%)',
              angle: -90,
              position: 'insideLeft',
              offset: -20
            }} stroke="#666" domain={[100, 'auto']} padding={{
              top: 20,
              bottom: 20
            }} data-id="element-78" />
                <Tooltip formatter={formatTooltip} contentStyle={{
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              border: '1px solid #e0e0e0',
              borderRadius: '4px'
            }} data-id="element-79" />
                <Legend wrapperStyle={{
              paddingTop: '20px'
            }} data-id="element-80" />
                <Line type="monotone" dataKey="percentage" name={`${artworkName} Value`} stroke="#8884d8" strokeWidth={3} dot={{
              stroke: '#8884d8',
              strokeWidth: 2,
              r: 6,
              fill: '#fff'
            }} activeDot={{
              r: 8,
              stroke: '#8884d8',
              strokeWidth: 2,
              fill: '#fff'
            }} data-id="element-81" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </>}
    </div>;
}